import styled from 'styled-components';
import { Button } from 'antd';
import { CssSpace } from '@xbcb/ui-types';

export const StyledDiv = styled.div`
  .info-tooltip,
  h4 {
    margin-left: ${CssSpace.SPACE_3};
    display: inline-block;
  }
  margin-bottom: ${CssSpace.SPACE_4};
`;

export const StyledButton = styled(Button)`
  margin-left: ${CssSpace.SPACE_3};
`;
